document.addEventListener('DOMContentLoaded', function () {
    // Tab functionality
    const tabButtons = document.querySelectorAll('.mega-menu-wrapper .tab-btn');
    const tabContents = document.querySelectorAll('.mega-menu-wrapper .tab-content');

    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');

        // Remove active class from all buttons and contents
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        tabContents.forEach((content) => content.classList.remove('active'));

        // Add active class to clicked button and corresponding content
        this.classList.add('active');
        const targetContent = document.getElementById(targetTab);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });

    // Close mega menu when clicking outside
    document.addEventListener('click', function (event) {
      const megaMenus = document.querySelectorAll('.menu-on-hover');
      const menuContainers = document.querySelectorAll('.menu-container');

      let clickedInsideMenu = false;

      menuContainers.forEach((container) => {
        if (container.contains(event.target)) {
          clickedInsideMenu = true;
        }
      });

      if (!clickedInsideMenu) {
        megaMenus.forEach((menu) => {
          // Use CSS classes instead of inline styles
          menu.classList.add('menu-hidden');
          menu.classList.remove('menu-visible');
          // Remove any inline styles that might conflict
          menu.style.opacity = '';
          menu.style.visibility = '';
        });
        
        // Remove active class from all menu containers
        menuContainers.forEach((container) => {
          container.classList.remove('active');
        });
      }
    });

    // Add hover event listeners to menu containers
    const menuContainers = document.querySelectorAll('.menu-container');
    
    menuContainers.forEach((container) => {
      const megaMenu = container.querySelector('.menu-on-hover');
      
      if (megaMenu) {
        container.addEventListener('mouseenter', function() {
          // Add active class to menu container
          this.classList.add('active');
          
          megaMenu.classList.remove('menu-hidden');
          megaMenu.classList.add('menu-visible');
          // Clear any conflicting inline styles
          megaMenu.style.opacity = '';
          megaMenu.style.visibility = '';
        });
        
        container.addEventListener('mouseleave', function() {
          // Remove active class from menu container
          this.classList.remove('active');
          
          megaMenu.classList.remove('menu-visible');
          megaMenu.classList.add('menu-hidden');
        });
      }
    });
});